import {
  GET_TABLE_TO_SEND_EMAIL,
  SET_LOADING,
  GET_DATA_FOR_SELECT,
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATES_FOR_SELECT,
  GET_EMAIL_HISTORY_TABLE,
  GET_EMAIL_HISTORY_READ_TABLE,
  GET_EMAIL_HISTORY_TOTAL_TABLE,
  GET_EMAIL_HISTORY_FILTERS,
  CLEAR_TEMPLATE,
  GET_EMAIL_HISTORY_CLICK_TABLE,
  GET_EMAIL_HISTORY_REPORTS,
} from './types'

const initialState = {
  // table to send email
  tableToSendEmail: {},
  dataForSelect: {},
  //template
  emailTemplate: {},
  emailTemplates: {},
  emailTemplatesForSelect: [],
  // history tables
  emailHistoryTable: {},
  emailHistoryTotalTable: {},
  emailHistoryReadTable: {},
  emailHistoryClickTable: {},
  emailHistoryReports: {},
  emailHistoryFilters: [],
  isLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TABLE_TO_SEND_EMAIL:
      return {
        ...state,
        tableToSendEmail: action.payload,
        isLoading: false,
      }
    case GET_DATA_FOR_SELECT:
      return {
        ...state,
        dataForSelect: action.payload,
      }
    case GET_EMAIL_TEMPLATE:
      return {
        ...state,
        emailTemplate: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_TEMPLATES:
      return {
        ...state,
        emailTemplates: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_TEMPLATES_FOR_SELECT:
      return {
        ...state,
        emailTemplatesForSelect: action.payload,
      }
    case GET_EMAIL_HISTORY_TABLE:
      return {
        ...state,
        emailHistoryTable: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_HISTORY_TOTAL_TABLE:
      return {
        ...state,
        emailHistoryTotalTable: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_HISTORY_READ_TABLE:
      return {
        ...state,
        emailHistoryReadTable: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_HISTORY_CLICK_TABLE:
      return {
        ...state,
        emailHistoryClickTable: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_HISTORY_FILTERS:
      return {
        ...state,
        emailHistoryFilters: action.payload,
        isLoading: false,
      }
    case GET_EMAIL_HISTORY_REPORTS:
      return {
        ...state,
        emailHistoryReports: action.payload,
        isLoading: false,
      }
    case CLEAR_TEMPLATE:
      return {
        ...state,
        emailTemplate: {},
      }
    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    default:
      return state
  }
}
